import React from 'react';

import { createRoot } from 'react-dom/client';

import App from '@/App';
import { takeInvitationTokenFromUrl } from '@/features/invitations/invitationToken';
import * as serviceWorker from '@/serviceWorker';
import { datadogRumInit } from '@/utils/Datadog';
import Sentry from '@/utils/Sentry';

import 'normalize.css';
import '@/styles/global.scss';
import './bootstrap.scss';

takeInvitationTokenFromUrl();
datadogRumInit();
Sentry.setup();

const container = document.getElementById('root');
if (!container) throw new Error("Fail: Couldn't find root element");
const root = createRoot(container);

root.render(
  import.meta.env.DEV ? (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ) : (
    <App />
  ),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
